import React, { Fragment } from "react";
import { useState, useEffect } from "react";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import { Container, Card, Col, Row, Form ,InputGroup} from "react-bootstrap";
import { connect } from 'react-redux';
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router";
import studentInfoApi from "../api/studentInfoAPI";
import { useSelector } from "react-redux";

function SystemMessage({setAlert}) {
  useEffect(() => {
      fetchMessageDataNetwork();
      fetchMessageDataEmail();
      fetchMessageDataSIS();
      fetchITNews();
  }, []); 

  const loginName = useSelector( 
    (state) => state.userProps.loginId + " : " + state.userProps.role 
  );
  const userRole = useSelector((state) => state.userProps.role);
   const [key, setKey] = useState("home");

  
  const [formDataSystemMessage, setormDataSystemMessage] = useState({
    Type: "",
    Message: "",
  });


 
/*UPDATE*/
  const UpdateMessageDataNetwork = async (e) => {
    e.preventDefault();
    
    var message = document.getElementById('txtMessage').value;
    formDataSystemMessage.type = 'Standard';
    formDataSystemMessage.message = message;
    
    var myAPI = new studentInfoApi();
    var _DATA = await myAPI.UpdateMessageDataNetwork(formDataSystemMessage) 
    window.alert("System Message Updated");

  }

    const UpdateMessageDataEmail = async (e) => {
    e.preventDefault();
    
    var message = document.getElementById('txtMessage2').value;
    formDataSystemMessage.type = 'Standard';
    formDataSystemMessage.message = message;
    
    var myAPI = new studentInfoApi();
    var _DATA = await myAPI.UpdateMessageDataEmail(formDataSystemMessage) 
    window.alert("System Message Updated");

  }

    const UpdateMessageDataSIS = async (e) => {
    e.preventDefault();
    
    var message = document.getElementById('txtMessage3').value;
    formDataSystemMessage.type = 'Standard';
    formDataSystemMessage.message = message;
    
    var myAPI = new studentInfoApi();
    var _DATA = await myAPI.UpdateMessageDataSIS(formDataSystemMessage) 
    window.alert("System Message Updated");

  }


    const UpdateMessageITNews = async (e) => {
    e.preventDefault();

    var message = document.getElementById('txtMessageITNews').value;
    formDataSystemMessage.type = 'Standard';
    formDataSystemMessage.message = message;

    var myAPI = new studentInfoApi();
    var _DATA = await myAPI.UpdateMessageITNews(formDataSystemMessage)
    window.alert("IT News Message Updated");

  }

  /*DELETE*/
    const DeleteMessageDataNetwork = async (e) => {
      e.preventDefault();

      var myAPI = new studentInfoApi();
      var _DATA = await myAPI.DeleteMessageDataNetwork();
      window.alert("System Message Deleted");
      document.getElementById('txtMessage').value = "";
    };

    const DeleteMessageDataEmail = async (e) => {
      e.preventDefault();

      var myAPI = new studentInfoApi();
      var _DATA = await myAPI.DeleteMessageDataEmail();
      window.alert("System Message Deleted");
      document.getElementById('txtMessage2').value = "";
    };

    const DeleteMessageDataSIS = async (e) => {
      e.preventDefault();

      var myAPI = new studentInfoApi();
      var _DATA = await myAPI.DeleteMessageDataSIS();
      window.alert("System Message Deleted");
      document.getElementById('txtMessage3').value = "";
    };

    const DeleteMessageDataNetworkITNews = async (e) => {
      e.preventDefault(); 
      var myAPI = new studentInfoApi();
      var _DATA = await myAPI.DeleteMessageDataNetworkITNews();
      window.alert("IT News Message Deleted");
      document.getElementById('txtMessageITNews').value = "";
    };


    /*FETCH*/
     var statusMessageNetwork = "";
      const fetchMessageDataNetwork = async () => {
        var myAPI = new studentInfoApi();
        statusMessageNetwork = await myAPI.fetchMessageDataNetwork();
        console.log("Fetched Network Message:", statusMessageNetwork[0].Message);
        const editor = document.getElementById("txtMessage");
        if(statusMessageNetwork[0].Message !== null && statusMessageNetwork[0].Message !== '' && statusMessageNetwork[0].Message !== undefined) {
          editor.value = statusMessageNetwork[0].Message;
        }
      
      };
    
      var statusMessageEmail = "";
      const fetchMessageDataEmail = async () => {
        var myAPI = new studentInfoApi();
        statusMessageEmail = await myAPI.fetchMessageDataEmail();
        const editor = document.getElementById("txtMessage2");
        console.log("Fetched Email Message:", statusMessageEmail[0].Message);
        if(statusMessageEmail[0].Message !== null && statusMessageEmail[0].Message !== '' && statusMessageEmail[0].Message !== undefined) {
          editor.value = statusMessageEmail[0].Message;
        }
      };
    
      var statusMessageSIS = "";
      const fetchMessageDataSIS = async () => {
        var myAPI = new studentInfoApi();
        statusMessageSIS = await myAPI.fetchMessageDataSIS();
        const editor = document.getElementById("txtMessage3");
        console.log("Fetched SIS Message:", statusMessageSIS[0].Message);
        if(statusMessageSIS[0].Message !== null && statusMessageSIS[0].Message !== '' && statusMessageSIS[0].Message !== undefined) {
          editor.value = statusMessageSIS[0].Message;
        }
      };

       var statusITNews = "";
      const fetchITNews = async () => {
        var myAPI = new studentInfoApi();
        statusITNews = await myAPI.fetchITNews();
        const editor = document.getElementById("txtMessageITNews");
        console.log("Fetched IT News:", statusITNews[0].Message);
        if(statusITNews[0].Message !== null && statusITNews[0].Message !== '' && statusITNews[0].Message !== undefined) {
          editor.value = statusITNews[0].Message;
        }
      };

      

  /*Application Date Management */

  var htmlString = 'To add a hyperlink in the welcome message, please use the following format ';
        htmlString += '<a href="Enter URL">Visit Name of the site!</a>'
   var  htmlString2 =  'Example: <a href="https//houstonisd.org">Visit houstonisd!</a>';
   htmlString2 = htmlString2 + '  If you want to bold text, you can enclose it in <b> </b> tags. ';

  //{ userRole  === "Admin" ? ( <Fragment> </Fragment> ): (<h4></h4) }
  return (
    <div>
      <main>
        <Container
          fluid
          className="p-4 bg-light d-flex flex-column align-items-center"
        >
          {/*
          {userRole === "Admin" ? ( */}

          <Row style={{ marginTop: "10px", width: "90rem" }}>
            <Col xl={12} lg={6}>
              <Card className="h-100 shadow-sm">
                <Card.Body className="d-flex flex-column">
                  <div className="mb-4">
                    <Card.Title as="h3">📢 Alerts And News</Card.Title>
                    <Card.Subtitle className="text-muted">
                      Enter System Messages for Alerts and Notifications
                    </Card.Subtitle>
                  </div>

                  <Form>
                    <Row>
                      <label>{htmlString}</label>
                    </Row>
                    <Row style={{ marginBottom: "10px" }}>
                      <label>
                        <strong>Adding a Hyperlink:</strong> To add a link, use
                        the HTML tag &lt;a&gt;.
                        <ul>
                          <li>
                            Format: &lt;a href="YourURLHere"&gt;Your Text to
                            Display Here&lt;/a&gt;
                          </li>
                          <li>
                            Example: &lt;a
                            href="https://houstonisd.org"&gt;Visit Houston
                            ISD&lt;/a&gt; (Will display as{" "}
                            <a href="https://houstonisd.org">
                              Visit Houston ISD
                            </a>
                            .)
                          </li>
                        </ul>
                        <strong>Making Text Bold:</strong> To make text stand
                        out, use the &lt;b&gt; HTML tag to make it bold.
                        <ul>
                          <li>Format: &lt;b&gt;Your Text Here&lt;/b&gt;</li>
                          <li>
                            Example: &lt;b&gt;Network Outage:&lt;/b&gt; HISD's
                            network is currently down. (Will display as{" "}
                            <strong>Network Outage:</strong> HISD's network is
                            currently down.)
                          </li>
                        </ul>
                      </label>
                    </Row>

                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                    >
                      {userRole === "Admin" && userRole !== "ASKIT_News" ? (
                        <Tab
                          eventKey="ITAlerts"
                          title="System Messages for Alerts and Notifications"
                        >
                          <Row>
                            <Form.Group className="mb-3">
                              <Form.Label>Alert One:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                id="txtMessage"
                              />
                            </Form.Group>
                          </Row>

                          <Row style={{ marginTop: "10px" }}>
                            <Col sm={6}>
                              <Button
                                id="submit"
                                variant="primary"
                                onClick={(e) => UpdateMessageDataNetwork(e)}
                              >
                                Submit
                              </Button>
                              <Button
                                id="submit"
                                variant="danger"
                                style={{ marginLeft: "10px" }}
                                onClick={(e) => DeleteMessageDataNetwork(e)}
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>

                          <hr></hr>
                          <Row>
                            <Form.Group className="mb-3">
                              <Form.Label>Alert Two:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                id="txtMessage2"
                              />
                            </Form.Group>
                          </Row>

                          <Row style={{ marginTop: "10px" }}>
                            <Col sm={6}>
                              <Button
                                id="submit"
                                variant="primary"
                                onClick={(e) => UpdateMessageDataEmail(e)}
                              >
                                Submit
                              </Button>
                              <Button
                                id="submit"
                                variant="danger"
                                style={{ marginLeft: "10px" }}
                                onClick={(e) => DeleteMessageDataEmail(e)}
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>
                          <hr></hr>
                          <Row>
                            <Form.Group className="mb-3">
                              <Form.Label>Alert Three:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                id="txtMessage3"
                              />
                            </Form.Group>
                          </Row>

                          <Row style={{ marginTop: "10px" }}>
                            <Col sm={6}>
                              <Button
                                id="submit"
                                variant="primary"
                                onClick={(e) => UpdateMessageDataSIS(e)}
                              >
                                Submit
                              </Button>
                              <Button
                                id="submit"
                                variant="danger"
                                style={{ marginLeft: "10px" }}
                                onClick={(e) => DeleteMessageDataSIS(e)}
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>
                        </Tab>
                      ) : (
                        <h1></h1>
                      )}

                      {userRole === "Admin" || userRole === "ASKIT_News" ? (
                        <Tab eventKey="ITNews" title="IT News">
                          <Row>
                            <Form.Group className="mb-3">
                              <Form.Label>Enter IT News:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                id="txtMessageITNews"
                              />
                            </Form.Group>
                          </Row>

                          <Row style={{ marginTop: "10px" }}>
                            <Col sm={6}>
                              <Button
                                id="submit"
                                variant="primary"
                                onClick={(e) => UpdateMessageITNews(e)}
                              >
                                Submit
                              </Button>
                              <Button
                                id="submit"
                                variant="danger"
                                style={{ marginLeft: "10px" }}
                                onClick={(e) =>
                                  DeleteMessageDataNetworkITNews(e)
                                }
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>
                        </Tab>
                      ) : (
                        <h1></h1>
                      )}
                    </Tabs>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/*
          ) : (
            <h4>You are not authorized to view admin section</h4>
          )} */}
        </Container>
      </main>
    </div>
  );
}
//export default Admin;
const mapStateToProps = state => ({
})
export default connect(mapStateToProps)(SystemMessage)
